import * as types from "../action/ActionType";
import type { InvoiceFormValues } from "../../types/api";

type FormDataState = InvoiceFormValues;

interface FormDataAction {
  type: string;
  payload: FormDataState;
}

export default function Invoiceformdata(
  state: FormDataState = {},
  action: FormDataAction
): FormDataState {
  const { type, payload } = action;
  switch (type) {
    case types.UPDATE_FORMDATA:
      return payload;
    default:
      return state;
  }
}
